module.exports = __webpack_public_path__ + "img/logo_MPT.b57268fa.png";